//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

import $ from "jquery";

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.service('NotesService', [
    '$rootScope',
    'NotesApiService',
    function(
            $rootScope,
            NotesApiService,
        ) {
      let notesPromise = null;
      let notes = null;

      this.getTypeaheadUsersAsync = function() {
        return NotesApiService.getTypeaheadUsersAsync();
      };

      this.getSubscriptionsAsync = function(itemId) {
        return NotesApiService.getSubscriptionsAsync(itemId);
      };

      this.subscribeUserAsync = function(itemId, userId) {
        const params = { userId, optIn: true };
        return NotesApiService.updateUserSubscriptionAsync(itemId, params);
      };

      this.unsubscribeUserAsync = function(itemId, userId) {
        const params = { userId, optIn: false };
        return NotesApiService.updateUserSubscriptionAsync(itemId, params);
      };

      this.getNotesAsync = function(itemId) {
        const self = this;

        if (!notesPromise) {
          notesPromise = NotesApiService.getNotesAsync(itemId).then((response) => {
            notes = response.notes;
            return response;
          });
        } else {
          self.refreshNotesAsync(itemId);
        }

        return notesPromise;
      };

      this.getNotesSync = function() {
        return notes;
      };

      this.addNoteAsync = function(itemId, text, mentionedUsers) {
        const self = this;

        return NotesApiService.addNoteAsync(itemId, text, mentionedUsers).then(() => {
          return self.refreshNotesAsync(itemId);
        });
      };

      this.refreshNotesAsync = function(itemId) {
        notesPromise = NotesApiService.getNotesAsync(itemId).then((response) => {
          const newNotes = response.notes;

          if (!angular.equals(notes, newNotes)) {
            notes = newNotes;
            $rootScope.$broadcast('uia:notes-changed', notes);
          }
          return response;
        });

        return notesPromise;
      };

            /**
             * Extract the mentioned users from an element that are contaiend within <span> tags
             * Returns both the names/ids of users
             * Also returns the indices at which they are mentioned (vs the indices where their names are used in regular text)
             *
             * @param noteInputElement      An element containing <span> tags of users with user-id attributes to be extracted
             */
      this.getMentionedUsers = function(noteInputElement) {
        return _.chain(noteInputElement.getElementsByTagName('span')).filter((anyElement) => {
          return !!$(anyElement).attr('user-id');
        }).map((mentionElement) => {
          const fullString = angular.copy(noteInputElement.innerHTML);
          const nameOfUser = $(mentionElement).text().trim();

          const splitFullString = fullString.split(nameOfUser);

          const indexList = splitFullString.map((item, index) => {
            const previousString = splitFullString[index - 1];

            if (item && previousString &&
                            item.indexOf('</span>') === 0 &&
                            previousString.split('').reverse().join('').indexOf('>') === 0) {
              return index - 1;
            } else {
              return null;
            }
          });

          const filteredIndexList = indexList.filter((item) => {
            return item !== null;
          });

          return {
            id: parseInt($(mentionElement).attr('user-id'), 10),
            name: nameOfUser,
            indices: filteredIndexList,
          };
        }).value();
      };
    },
  ]);
})();
